var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List } from "@mui/material";
import { AutocompleteOptionType, Text } from "../../../../../Atoms";
import { HookAutocomplete } from "../../../../../Molecules";
import { CheckBoxOption, CheckIconOption, } from "../../../../../Atoms/Inputs/Autocomplete/components";
var LocationAutocomplete = function (_a) {
    var groupLabel = _a.groupLabel, options = _a.options, optionType = _a.optionType, callback = _a.callback, placeholder = _a.placeholder, name = _a.name, actionRef = _a.actionRef;
    /**
     * Wrapping popover isnt aware of the size changing, we need to explicitly tell it to update its posiiton
     * so the list of options doesnt go off screen
     */
    var onOpen = function () {
        setTimeout(function () {
            var _a;
            (_a = actionRef === null || actionRef === void 0 ? void 0 : actionRef.current) === null || _a === void 0 ? void 0 : _a.updatePosition();
        }, 250);
    };
    var onClose = function () {
        setTimeout(function () {
            var _a;
            (_a = actionRef === null || actionRef === void 0 ? void 0 : actionRef.current) === null || _a === void 0 ? void 0 : _a.updatePosition();
        }, 250);
    };
    return (_jsx(HookAutocomplete, { name: name, options: options, maxHeight: 75, readOnly: false, callback: callback, onOpen: onOpen, inline: true, onClose: onClose, optionsLimit: 51, textFieldProps: {
            placeholder: placeholder,
        }, disabled: !(options === null || options === void 0 ? void 0 : options.length), getOptionLabel: function (option) { return option.name; }, groupBy: groupLabel ? function () { return groupLabel; } : undefined, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, renderGroup: function (params) {
            return (_jsxs(List, { children: [_jsx(Text, __assign({ ml: 4, variant: "overline", emphasis: "disabled" }, { children: params.group })), _jsx(List, { children: params.children })] }, params.key));
        }, renderOption: function (renderProps, option, state) {
            return optionType === AutocompleteOptionType.CheckBox ? (_jsx(CheckBoxOption, { renderProps: renderProps, option: option, state: state }, option.id)) : (_jsx(CheckIconOption, { renderProps: renderProps, option: option, state: state }, option.id));
        } }));
};
export default LocationAutocomplete;
